import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';

ReactDOM.render(
	React.createElement(App),
	document.getElementById('tv_chart_container_')
);
  



// WEBPACK FOOTER //
// ./src/index.js